/**
 * HH · Footer (sections/hh-footer.liquid)
 *
 * - Menús: abiertos siempre en escritorio; en el celular funcionan como acordeón.
 * - Estado de la tienda: «Abierto / Cierra pronto / Cerrado» con la hora de Honduras,
 *   sin importar la zona horaria de quien visita. Se revisa cada minuto.
 */

const DESKTOP = '(min-width: 750px)';
const PRONTO_MINUTOS = 30;
const DIAS = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

/** @param {string} value "HH:MM" en 24 horas */
function aMinutos(value) {
  const [h, m] = String(value || '').split(':').map((part) => parseInt(part, 10));
  if (Number.isNaN(h)) return null;
  return h * 60 + (Number.isNaN(m) ? 0 : m);
}

/** @param {number} minutos */
function formatoHora(minutos) {
  const h = Math.floor(minutos / 60) % 24;
  const m = minutos % 60;
  const sufijo = h < 12 ? 'AM' : 'PM';
  return `${h % 12 || 12}:${String(m).padStart(2, '0')} ${sufijo}`;
}

/** @param {string} zona */
function ahoraEn(zona) {
  let partes;
  try {
    partes = new Intl.DateTimeFormat('en-US', {
      timeZone: zona || 'America/Tegucigalpa',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false,
    }).formatToParts(new Date());
  } catch (error) {
    partes = new Intl.DateTimeFormat('en-US', {
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false,
    }).formatToParts(new Date());
  }
  const valor = (tipo) => partes.find((parte) => parte.type === tipo)?.value || '0';
  return {
    dia: DIAS[valor('weekday')] ?? 0,
    minutos: (parseInt(valor('hour'), 10) % 24) * 60 + parseInt(valor('minute'), 10),
  };
}

class HhFooter extends HTMLElement {
  connectedCallback() {
    this.mq = window.matchMedia(DESKTOP);
    this.syncMenus = () => {
      for (const menu of this.querySelectorAll('details[data-hh-acordeon]')) {
        menu.open = this.mq.matches;
      }
    };
    this.onClick = (event) => {
      // En escritorio los menús no se cierran.
      if (this.mq.matches && event.target instanceof Element && event.target.closest('summary')) {
        event.preventDefault();
      }
    };

    this.syncMenus();
    this.mq.addEventListener('change', this.syncMenus);
    this.addEventListener('click', this.onClick);

    this.estado = this.querySelector('[data-hh-estado]');
    if (this.estado) {
      this.actualizarEstado();
      this.timer = window.setInterval(() => this.actualizarEstado(), 60000);
    }
  }

  disconnectedCallback() {
    this.mq?.removeEventListener('change', this.syncMenus);
    this.removeEventListener('click', this.onClick);
    window.clearInterval(this.timer);
  }

  actualizarEstado() {
    const el = /** @type {HTMLElement} */ (this.estado);
    const texto = el.querySelector('[data-hh-estado-texto]');
    const abre = aMinutos(el.dataset.abre);
    const cierra = aMinutos(el.dataset.cierra);
    if (!texto || abre === null || cierra === null) return;

    const dias = el.dataset.dias || '';
    const { dia, minutos } = ahoraEn(el.dataset.zona || '');
    const abiertoHoy = dias.includes(String(dia));

    let estado = 'cerrado';
    if (abiertoHoy && minutos >= abre && minutos < cierra) {
      estado = cierra - minutos <= PRONTO_MINUTOS ? 'pronto' : 'abierto';
    }

    const plantilla =
      estado === 'abierto' ? el.dataset.txtAbierto : estado === 'pronto' ? el.dataset.txtPronto : el.dataset.txtCerrado;
    const hora = formatoHora(estado === 'cerrado' ? abre : cierra);

    texto.textContent = String(plantilla || '').replace('[hora]', hora);
    el.dataset.estado = estado;
    el.hidden = false;
  }
}

if (!customElements.get('hh-footer')) {
  customElements.define('hh-footer', HhFooter);
}
